import { Box, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import { HamburgerIcon } from "assets/icons/HamburgerIcon";
import { GlobalSearch } from "components/modules/globalSearch/GlobalSearch";
import { IdentityButton } from "components/modules/IdentityButton";
import { useConfig } from "config/configHook";
import { RoleType } from "gql/graphql";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PushButton } from "../atoms/buttons/PushButton";
import { CreateOrganization } from "./dialogs/CreateOrganization";
import { InviteUser } from "./dialogs/InviteUser";

const LogoImg = styled("img")(({ theme }) => ({
  height: "32px",
  width: "auto",
  display: "block",
  marginLeft: theme.spacing(6),
}));

interface Props {
  onToggleMenu: () => void;
  isSupporter: boolean;
  userRoles: any;
  defaultRoute: string;
}

export const DashboardBanner = ({
  onToggleMenu,
  isSupporter,
  userRoles,
  defaultRoute,
}: Props) => {
  const config = useConfig();
  const theme = useTheme();
  const navigate = useNavigate();
  const largeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  const [inviteUserDialogOpen, setInviteUserDialogOpen] = useState(false);
  const [createOrgDialogOpen, setCreateOrgDialogOpen] = useState(false);

  const showInviteUserButton =
    userRoles.includes(RoleType.Owner) || userRoles.includes(RoleType.Editor);

  const handleGoToDefaultRoute = () => {
    navigate(defaultRoute);
  };

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        paddingLeft: 4,
        paddingRight: 6,
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        zIndex: 1100,
        height: 86,
        minHeight: 86,
      })}
    >
      <Box
        sx={{
          width: 242,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Box
          sx={(theme) => ({
            height: 40,
            width: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            path: {
              color: theme.palette.grey[600],
            },
            ":hover path": {
              color: theme.palette.primary.main,
            },
          })}
          onClick={onToggleMenu}
        >
          <HamburgerIcon />
        </Box>
        <LogoImg
          style={{ cursor: "pointer" }}
          src={config.logo?.defaultLogo}
          onClick={handleGoToDefaultRoute}
        />
      </Box>
      <Box
        sx={(theme) => ({
          display: "flex",
          flex: 1,
          alignItems: "center",
          ml: theme.spacing(4),
        })}
      >
        <GlobalSearch isSupporter={isSupporter} />
      </Box>

      {largeScreen ? (
        <Box
          sx={(theme) => ({
            display: "flex",
            marginLeft: theme.spacing(6),
            alignItems: "center",
          })}
        >
          {isSupporter ? (
            <PushButton
              variant="outlined"
              onClick={() => setCreateOrgDialogOpen(true)}
            >
              New organization
            </PushButton>
          ) : showInviteUserButton ? (
            <PushButton
              variant="outlined"
              onClick={() => setInviteUserDialogOpen(true)}
            >
              Invite user
            </PushButton>
          ) : null}
        </Box>
      ) : null}
      <Box
        sx={(theme) => ({
          display: "flex",
          marginLeft: theme.spacing(4),
          alignItems: "center",
        })}
      >
        <IdentityButton />
      </Box>
      <InviteUser
        open={inviteUserDialogOpen}
        onClose={() => setInviteUserDialogOpen(false)}
      />
      <CreateOrganization
        open={createOrgDialogOpen}
        onClose={() => setCreateOrgDialogOpen(false)}
      />
    </Box>
  );
};
